import { doorSettingsStateStore } from '../../assets/scripts/service/redux-service';
import { loadDoorSettingsState } from '../../assets/scripts/service/localStorage-service';
import { CalculateDoorSummary } from '../../assets/scripts/service/calculation-service';
const aaecState = require('../../json/state/aaec-state.json');
const languageJSON = require('../../json/language.json');

export const resultPage = (() => {

	const $resultPageCard = $('.result-page__card');
	const $projectNameWrapper = $('.result-page__project-name');
	const $projectName = $('.js-project-editable', '.result-page');
	const $editNameIcon = $('.name-edit-icon');
	const $print = $('.js-print');
	const $resultKwh = $('.result-kwh');
	const $doorDetails = $('.result-page__door-details');
	const $hubspot = $('.js-hubspot-btn');

	let doorState = aaecState;
	if (loadDoorSettingsState() !== undefined) {
		doorState = loadDoorSettingsState();
	}

	//get inital state 
	updateValuesOnResultPage(doorState, doorState.unit, doorState.savings);
	updateDoorImage(doorState);

	// Update the UI in response to (redux) state changes.
	doorSettingsStateStore.subscribe(() => {
		const updatedDoorState = doorSettingsStateStore.getState();
		//console.log(updatedDoorState);
		updateValuesOnResultPage(updatedDoorState, updatedDoorState.unit, updatedDoorState.savings);
		updateDoorImage(updatedDoorState);
	});

	// Select result card
	$resultPageCard.each(function (index) {
		$(this).on("click", function () {
			$resultPageCard.removeClass('is-selected');
			$(this).addClass('is-selected');
		});
	})

	//Gets the highest div of the door details and makes all the door details the same hight.
	function getHighestElement() {
		let maxHeight = 0;

		$doorDetails.each(function () {
			maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
		});
		$doorDetails.each(function () {
			$(this).height(maxHeight - 20);
		});
	}
	getHighestElement();

	// PROJECT NAME LOGIC
	// Click on the edit name icon to focus the name
	$editNameIcon.on('click', function (e) {
		$projectName.focus();
		$(this).hide();
		$projectNameWrapper.css({ "border-bottom": "1px solid #7E939A" });
	});
	// Hide edit icon on projectname click
	$projectName.on('click', function (e) {
		$editNameIcon.hide();
		$projectNameWrapper.css({ "border-bottom": "1px solid #7E939A" });
	});
	// if press enter on contenteditable focus leav it
	$projectName.keydown(function (e) {
		// trap the return key being pressed
		if (e.keyCode === 13) {
			$(this).blur();
			$editNameIcon.show();
			$projectNameWrapper.css({ "border-bottom": "none" });
			return false;
		}
	});
	// Update project name
	$projectName.on("focusout", function (e) {
		doorSettingsStateStore.dispatch({ type: 'CHANGE_PROJECT_NAME', name: $(this).text() });
		$editNameIcon.show();
		$projectNameWrapper.css({ "border-bottom": "none" });
	});

	function updateValuesOnResultPage(doorState, unit = 'metric', savings = 'kWh') {
		let savingsValue = 1;

		//Updates if the calculator is going to show saving in kwh or money
		if (savings == 'kWh') {
			savingsValue = 1;
		} else {
			savingsValue = parseFloat(doorState.price);
		}
		let selectedLanguage = doorState
		let doorHeightMeter = doorState.door.properties.height;
		let doorWidthMeter = doorState.door.properties.width;
		if (unit == "imperial") {
			doorHeightMeter = doorState.door.properties.height / 3.2808;
			doorWidthMeter = doorState.door.properties.width / 3.2808;
		}
		let doorHeightmm = doorHeightMeter * 1000;
		let doorWidthmm = doorWidthMeter * 1000;
		let doorWindowPanel = doorState.door.properties.numberOfWindowPanel;
		let doorLocationZone = doorState.door.properties.locationZone.climateZoneClass; //"Dfc";
		let doorOpeningFrequency = doorState.door.properties.openingFrequency;

		// Result element
		//let $resultKwhYear = $( '.result-kwh-year' );
		let $projectName = $('.js-project-editable', '.result-page');
		const $resultDoor = $('.result-door');
		var doorCalcResult = CalculateDoorSummary(doorWidthmm, doorHeightmm, doorWindowPanel, doorLocationZone, doorOpeningFrequency);

		$projectName.text(doorState.projectName);

		//gets all doors and sorts depending on the highest value
		let doorArray = [];

		for (var i = 0; i < 3; i++) {
			doorArray.push({
				name: doorCalcResult[i].Name,
				value: Math.round(doorCalcResult[i].kWyDiff * savingsValue)
			})
		}

		let sortedDoorArray = doorArray.sort(function (a, b) {
			return a.value - b.value;
		});

		//This checks if the door is larger than 5000 mm either in height or width
		if (sortedDoorArray[2].name == 'OH1042S') {
			if (doorHeightmm > 5000 || doorWidthmm > 5000) {
				let splicedItem = sortedDoorArray[2];
				sortedDoorArray.splice(2, 1, [0]);
				sortedDoorArray.splice(1, 0, splicedItem);
			}
		}

		$(sortedDoorArray).each(function (i) {
			//This checks if the door is larger than 5000 mm either in height or width
			//If true then the door will become unavailable

			if (sortedDoorArray[i].name == 'OH1042S') {
				if (doorHeightmm > 5000 || doorWidthmm > 5000) {
					$('.result-door#' + i).addClass('is-unavailable');
				} else {
					$('.result-door').removeClass('is-unavailable');
				}
			}
			let getLink = this.name + '-link';
			$('.result-page__name', '.result-door#' + i).text('ASSA ABLOY ' + this.name);
			$('.result-kwh-year', '.result-door#' + i).text(this.value);
			
			$('#' + i + ' ' + '.external-link').attr('href', languageJSON[selectedLanguage.language].resultPage[getLink]);
			$('.result-page__door-description', '.result-door#' + i).html(languageJSON[selectedLanguage.language].resultPage[this.name]);

			$resultKwh.text(savings);
		});

		if (isNaN(savingsValue)) {
			$('.fake-load, .kwh-price').addClass('error-state');
		} else {
			$('.fake-load, .kwh-price').removeClass('error-state');
		}

	}
	//Updates the values in the door image
	function updateDoorImage(doorState) {
		const $resulPageValueY = $('.result-page__value-y');
		const $resulPageValueX = $('.result-page__value-x');
		const $resultPageDoorWindows = $('.result-page__door-windows');
		const $resultPageDoorPanels = $('.result-page__door-panel');
		const $resultPageDoorOutput = $('.result-page__door-output');
		let doorHeightMeter = parseFloat(doorState.door.properties.height);
		let doorWidthMeter = parseFloat(doorState.door.properties.width);

		if (doorState.unit === 'imperial') {
			$resulPageValueY.text(doorHeightMeter + ' ft');
			$resulPageValueX.text(doorWidthMeter + ' ft');
			doorHeightMeter = Math.round(doorHeightMeter / 3.2808);
			doorWidthMeter = Math.round(doorWidthMeter / 3.2808);
		} else {
			$resulPageValueY.text(doorHeightMeter + ' m');
			$resulPageValueX.text(doorWidthMeter + ' m');
		}

		let height = 26 * (doorHeightMeter + 2);
		let width = 26 * (doorWidthMeter + 2);
		let roundValue = Math.round(doorHeightMeter) / 2;
		let calc = 26 * Math.round(roundValue);
		let setNumberOfWindowsPerPanel = Math.floor(doorWidthMeter);

		if (setNumberOfWindowsPerPanel % 1 == 0) {
			if (setNumberOfWindowsPerPanel == 7) setNumberOfWindowsPerPanel = 6;
			if (setNumberOfWindowsPerPanel == 8) setNumberOfWindowsPerPanel = 7;
			$resultPageDoorPanels.empty();
			for (var i = 0; i < setNumberOfWindowsPerPanel; i++) {
				$resultPageDoorPanels.append('<div class="window"></div>');
			}
		}

		$resultPageDoorWindows.attr('data-window', doorState.door.properties.numberOfWindowPanel)
		let getWindowPanelPositioning = Math.floor(doorHeightMeter) * 25 / 2;

		if (Math.floor(doorHeightMeter) % 2 != 0) {
			getWindowPanelPositioning = getWindowPanelPositioning + 13;
		}

		$resultPageDoorOutput.css({ "width": width + 'px', "height": height - 1 + 'px' });
		$resultPageDoorWindows.css({ "margin-bottom": getWindowPanelPositioning + 'px' });

		//Adds class that turns measurements red showing that it's unavailable
		if (doorHeightMeter > 5) {
			$('.is-unavailable .result-page__door-y').addClass('y-unavailable');
		} else {
			$('.result-page__door-y').removeClass('y-unavailable');
		}

		if (doorWidthMeter > 5) {
			$('.is-unavailable .result-page__door-x').addClass('x-unavailable');
		} else {
			$('.result-page__door-x').removeClass('x-unavailable');
		}

	}

	$print.on('click', function () {
		let printDoorState = loadDoorSettingsState();
		$('.js-print-window').text(printDoorState.door.properties.numberOfWindowPanel);
		$('.js-print-opening').text(Math.round(printDoorState.door.properties.openingFrequency / 365));
		$('.js-print-location').text(printDoorState.door.properties.locationZone.country + ' ' + printDoorState.door.properties.locationZone.region);
		window.print();
	});

	$hubspot.on('click', function () {
		let obj = loadDoorSettingsState();
		const hiddenInput = $('.hs_information input')
		let combinedData =
		"unit: " + obj.unit + ", " +
		"Height: " + obj.door.properties.height + ", " +
		"Width: " + obj.door.properties.width + ", " +
		"Number of window panels " + obj.door.properties.numberOfWindowPanel + ", " +
		"Opening frequency: " + obj.door.properties.openingFrequency + ", " +
		"Climate zone class: " + obj.door.properties.locationZone.climateZoneClass + ", " +
		"Country: " + obj.door.properties.locationZone.country + ", " +
		"Region: " + obj.door.properties.locationZone.region;
		hiddenInput.attr("value", combinedData);
	});

})();



// WEBPACK FOOTER //
// ./src/components/result-page/result-page.js